import React from 'react'
import { 
    HeaderContent,
    HeaderLogo,
    HeaderMainTitle,
    HeaderSecondaryTitle,
    HeaderTernaryTitle,
    HeaderWrapper,
    TitlesWrapper,
} from './Header.styled';
import Logo from "../../assets/images/hbcteyran.png";

export const Header = () => {
  return (
    <HeaderWrapper>
        <HeaderContent>
            <HeaderLogo src={Logo} alt="HBC Teyran" height="180px" />
            <TitlesWrapper>
                <HeaderMainTitle>Handball Club Teyran</HeaderMainTitle>
                <HeaderSecondaryTitle>Dossier licence</HeaderSecondaryTitle>
                <HeaderTernaryTitle>Saison 2022-2023</HeaderTernaryTitle>
            </TitlesWrapper>
        </HeaderContent>
    </HeaderWrapper>
  )
}
